const joinPath = (...segments) => segments.map(v => (v||'').trim()).filter(v => v).join('/').replace(/\/+/g, '/');
export const stripJoinPath = (...segments) => joinPath(...segments).replace(/(^[\/]*|[\/]*$)/g, '')

export default joinPath;
